import React, { useState } from 'react';

const PLACEHOLDER =
    "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'%3E%3Crect width='200' height='200' fill='%23e9ecef'/%3E%3Cg transform='translate(100,100)'%3E%3Crect x='-32' y='-26' width='64' height='50' rx='5' fill='none' stroke='%23adb5bd' stroke-width='4'/%3E%3Ccircle cx='0' cy='-4' r='13' fill='none' stroke='%23adb5bd' stroke-width='4'/%3E%3Crect x='-8' y='-36' width='16' height='8' rx='3' fill='%23adb5bd'/%3E%3C/g%3E%3C/svg%3E";

const ProductImage = ({ src, alt, className, style, loading, decoding, onClick, itemProp }) => {
    const [failed, setFailed] = useState(false);

    return (
        <img
            src={failed || !src ? PLACEHOLDER : src}
            alt={alt}
            className={className}
            style={style}
            loading={loading}
            decoding={decoding}
            onClick={onClick}
            itemProp={itemProp}
            onError={() => setFailed(true)}
        />
    );
};

export default ProductImage;
